import Component from './component.component';

export type { RegisterOptions as ComponentRegisterOptions } from './component.types';

export default Component;
